import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { NAV_HEIGHT } from "../Navigation/nav";
import "./home.css";
import { trackPortfolioVisit, trackSocialClick, trackResumeDownload, trackNavigation } from "../../utils/analytics";

const typingWords = [
  "Campaign Designer",
  "Full-Stack Developer",
];

const highlights = ["React", "JavaScript", "Node.js", "Python", "Java", "SQL", "AWS"];

function Home() {
  const githubLink = "https://github.com/Lusa-mata";
  const linkedinLink = "https://www.linkedin.com/in/lusaduma-ok-mata/";
  const credlyLink = "https://www.credly.com/users/lusaduma-mata";

  // const [index, setIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    // Track when Home section is loaded
    trackPortfolioVisit('home');

    let wordIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timerId;

    const tick = () => {
      const word = typingWords[wordIndex] || "";

      if (!deleting) {
        charIndex++;
        setDisplayText(word.slice(0, charIndex));
        if (charIndex === word.length) {
          deleting = true;
          timerId = setTimeout(tick, 500); // pause at end
          return;
        }
      } else {
        charIndex--;
        setDisplayText(word.slice(0, charIndex));
        if (charIndex === 0) {
          deleting = false;
          wordIndex = (wordIndex + 1) % typingWords.length;
          timerId = setTimeout(tick, 200); // brief pause before typing next word
          return;
        }
      }

      timerId = setTimeout(tick, 100);
    };

    tick();

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <div id="lusaduma-mata">
      <div className="center">
        <div className="home-container home-layout">
          {/* Top: name and title, centred across the full width like other headings */}
          <div className="home-heading">
            <section>
              <h1 className="heading">
                <span className="text autoplay">LUSADUMA MATA</span>
              </h1>
            </section>

            <h3 className="home-title">{displayText}</h3>
          </div>

          {/* Everything below the heading: photo on the left, introduction on the right */}
          <div className="home-content">
          <div className="profile-img">
            <img src="/images/WhatsApp Image 2026-10-22 at 05.22.02.jpeg" alt="Lusaduma Mata" />
          </div>

          <div className="home-intro-block">
            <p className="home-intro">
              I'm a software developer passionate about building practical, user-focused applications. I have experience developing web applications, working with databases and building solutions that address real-world problems.
              <br></br>Currently at IBM South Africa, I work across enterprise technology and campaign management while continuing to develop independent software projects.
            </p>

            <div className="home-tags">
              {highlights.map((tag) => (
                <span key={tag} className="home-tag">{tag}</span>
              ))}
            </div>

            <div className="button-container">
              <Link
                to="projects"
                smooth
                offset={-NAV_HEIGHT}
                duration={500}
                className="download-button"
                onClick={() => trackNavigation('home_view_projects')}
              >
                View my work
              </Link>
              <a
                href="/documents/Lusaduma Mata CV.pdf"
                className="download-button secondary-button"
                download
                onClick={() => trackResumeDownload('home_page')}
              >
                Download my CV
              </a>
            </div>

            <div className="social-icons">
              <a
                href={linkedinLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackSocialClick('linkedin')}
              >
                <img
                  src="/images/linkedin icon.png"
                  alt="LinkedIn Icon"
                  className="linkedin-icon"
                />
              </a>
              <a
                href={credlyLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackSocialClick('credly')}
              >
                <img
                  src="/images/credly icon.png"
                  alt="Credly Icon"
                  className="credly-icon"
                />
              </a>
              <a
                href={githubLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackSocialClick('github')}
              >
                <img
                  src="/images/github icon.png"
                  alt="GitHub Icon"
                  className="github-icon"
                />
              </a>
            </div>
          </div>
          </div>
        </div>
      </div>

      {/* Subtle invitation to keep scrolling */}
      {/* <div className="scroll-cue-wrapper">
        <Link
          to="about"
          smooth
          offset={-NAV_HEIGHT}
          duration={500}
          className="scroll-cue"
          onClick={() => trackNavigation('home_scroll_cue')}
        >
          Explore my work &#8595;
        </Link>
      </div> */}
    </div>
  );
}

export default Home;